import 'react-virtualized/styles.css';
import { AutoSizer, List } from 'react-virtualized';
import { useState } from 'react';
import useUpdated from 'hooks/useUpdated';

const VirtualList = ({ dictionary, status, search, onClick }) => {
  const [data, setData] = useState(dictionary);

  useUpdated(() => {
    if (!search) {
      setData(dictionary);
    } else {
      setData(dictionary.filter(x => {
        if (x.title.toLowerCase().indexOf(search) > -1) {
          return true;
        }
        if (x.tags && x.tags.find(y => y.toLowerCase().indexOf(search) > -1)) {
          return true;
        }
        return false;
      }));
    }
  }, search);

  const rowRenderer = ({ key, index, style }) => {

    return (
      <div key={key} className="ListRow" style={style}>
        <div className={`Content ${status[index] ? 'Correct' : status[index] === false ? 'Incorrect' : ''}`} onClick={() => onClick(data[index])}>
          <div className="Title">
            {data[index].title}
          </div>
          <div className="Description">
            {data[index].description}
          </div>
        </div>
      </div>
    );
  }

  return (
    <AutoSizer>
      {({ width, height }) => (
        <List
          width={width}
          height={height}
          rowCount={data.length}
          rowHeight={100}
          rowRenderer={rowRenderer}
        />
      )}
    </AutoSizer>
  );
};

export default VirtualList;